import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["quality", "kind", "cost"]
  static values = { prices: Object, defaultKinds: Array }

  connect() { this.quote() }

  quote() {
    const prices = this.pricesValue[this.qualityTarget.value] || {}
    const selected = this.kindTarget.value
    const kinds = selected === "all" ? Object.keys(prices) :
      (!selected || selected === "default" ? this.defaultKindsValue : [selected])
    const cost = kinds.reduce((sum, kind) => sum + Number(prices[kind] || 0), 0)
    this.costTarget.textContent = Math.ceil(cost).toLocaleString()
  }
}
